import { checkEmail, checkEmailProps } from '@/api/server/user/read';
import { Button } from '@mui/material';

export default function CheckEmail({ email }: checkEmailProps) {
  const handleClick = async () => {
    const re = await checkEmail(email);

    if (re) {
      // TODO 이미 등록된 사용자 이메일입니다.
    }
  };
  return <Button onClick={handleClick}>중복확인</Button>;
}
